import { render, staticRenderFns } from "./accessDenied.vue?vue&type=template&id=bbcb3ba4&scoped=true"
import script from "./accessDenied.vue?vue&type=script&lang=js"
export * from "./accessDenied.vue?vue&type=script&lang=js"
import style0 from "./accessDenied.vue?vue&type=style&index=0&id=bbcb3ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb3ba4",
  null
  
)

export default component.exports